// extracted by mini-css-extract-plugin
export default {"chart":"BorrowerProjectAboutIndicators_chart__MoIBr","progress":"BorrowerProjectAboutIndicators_progress__Hm3A7"};